import React, { useState, useEffect, useRef } from 'react';

import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../../components/mensajes2';
import useTable from "../../components/useTable";
import { Dimmer } from "../../components/spinner";
import { GestionarCuentasBancarias } from './modalCuentaBancario';
import { Toasts } from '../toasts';
import { Input } from '../../ui/inputs/Input';
import { PrimaryButton } from '../../ui/buttons/Button';
import CardsModule from "../cartas";
// IMPORTS DE MATERIAL UI
import {
  Card,
  CardContent,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
// IMPORTS DE CHART JS
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

// Registrar los componentes necesarios de Chart.js
ChartJS.register(ArcElement, Tooltip, Legend);

const TablaCuentasBancarias = (props) => {

    var op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const headCells = [
        { 
            id: 'codigo', 
            backgroundColor: 'rgba(5, 81, 130, 1)', 
            color: '#ffffff', 
            label: 'COD.', 
            textAlign: 'center',
            width: '80px',
            fontSize: '10px'
        },
        { 
            id: 'descripcion', 
            backgroundColor: 'rgba(5, 81, 130, 1)', 
            color: '#ffffff', 
            label: 'DESCRIPCIÓN', 
            textAlign: 'center',
            width: '400px',
            fontSize: '10px'
        },
        { 
            id: 'estado', 
            backgroundColor: 'rgba(5, 81, 130, 1)', 
            color: '#ffffff', 
            label: 'NÚMERO DE CUENTA', 
            textAlign: 'center',
            width: '180px',
            fontSize: '10px'
        },
        { 
            id: 'opciones', 
            backgroundColor: 'rgba(5, 81, 130, 1)', 
            color: '#ffffff', 
            label: 'OPCIONES', 
            textAlign: 'center',
            width: '180px',
            fontSize: '10px'
        },
    ]

    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const txtBuscador = useRef();
    const [mostrar2, setMostrar2] = useState(false);
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [operacion, setOperacion] = useState(1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [bancos, setBancos] = useState();
    const [grafica, setGrafica] = useState({}); // Objeto para almacenar los tipos y sus cantidades
    const [chartLabels, setChartLabels] = useState([]); // Labels dinámicos
    const [chartValues, setChartValues] = useState([]); // Valores dinámicos
    const [backgroundColors, setBackgroundColors] = useState([]); // Colores dinámicos
    const permiso = JSON.parse(localStorage.getItem('acccuentabancaria')) === null ? "0000" : JSON.parse(localStorage.getItem('acccuentabancaria'));

    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: '',
        titulo: ''
    })

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                if (target.value === "")
                    return items;
                else
                    return items.filter(x => {
                        if ((x.idcuentabancaria !== null ? x.idcuentabancaria.includes(target.value) : '')
                            || (x.nombre !== null ? x.nombre.toLowerCase().includes(target.value.toLowerCase()) : '')
                            || (x.cuentabancaria !== null ? x.cuentabancaria.includes(target.value) : '')
                            || (x.tipo !== null ? x.tipo.toLowerCase().includes(target.value.toLowerCase()) : '')
                        ) {
                            return x;
                        }
                    });
            }
        })
    }

    const seleccionarRegistros = () => {
        let campos = "*";
        let nomtab = "cuentabancaria";
        let orden = "idcuentabancaria";

        let endpoint = op.conexion + `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        setActivate(true);
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    setRecords(response.data);
                    // Procesar datos para la gráfica según el campo TIPO (texto)
                    procesarDatosGrafica(response.data);
                }
                setActivate(false);
            })
            .catch(function (error) {
                setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
                setActivate(false);
            });
    };

    // Función para procesar los datos de la gráfica basada en el campo TIPO (texto)
    const procesarDatosGrafica = (data) => {
        // Crear un objeto para contar los tipos
        const conteoTipos = {};
        
        data.forEach(item => {
            // Limpiar el texto del tipo (eliminar espacios extras)
            const tipo = item.tipo ? item.tipo.trim() : 'SIN TIPO';
            
            if (conteoTipos[tipo]) {
                conteoTipos[tipo]++;
            } else {
                conteoTipos[tipo] = 1;
            }
        });
        
        // Ordenar los tipos de mayor a menor cantidad
        const tiposOrdenados = Object.entries(conteoTipos)
            .sort((a, b) => b[1] - a[1])
            .reduce((obj, [key, value]) => {
                obj[key] = value;
                return obj;
            }, {});
        
        setGrafica(tiposOrdenados);
        
        // Generar labels y valores
        const labels = Object.keys(tiposOrdenados);
        const values = Object.values(tiposOrdenados);
        
        setChartLabels(labels);
        setChartValues(values);
        
        // Generar colores dinámicos
        const colors = generateColors(labels.length);
        setBackgroundColors(colors);
    };

    const seleccionarBanco = (id) => {
        let campos = "*";
        let nomtab = 'cuentabancaria';
        let nomid = 'idcuentabancaria';
        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid} `
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                if (response.data.idcuentabancaria !== '') {
                    setBancos(response.data)
                    setMostrar2(true)
                    setActivate(false)
                }
            }
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const cerrarModal = () => {
        setMostrar2(false)
    }

    const gestionarBanco = (op, id, per) => (e) => {
        e.preventDefault();
        if (per.toString() === '1') {
            setOperacion(op);
            if (op === 4) {
                seleccionarBanco(id);
            } else if (op === 1) {
                setMostrar2(true)
            } else if (op === 2) {
                seleccionarBanco(id);
            } else if (op === 3) {
                seleccionarBanco(id);
            }
        } else {
            setToast({
                mostrar: true,
                mensaje: op === 1 ? 'No posee permiso para Registrar' : op === 2 ? 'No posee permiso para Editar' : op === 3 ? 'No posee permiso para Eliminar' : 'No posee permiso para Consultar',
                titulo: 'Alerta.'
            })
        }
    }

    const cerrarToast = () => {
        setToast({
            mostrar: false
        })
    }

    const handleCloseSi = () => {
        setActivate(false);
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })
    };

    useEffect(() => {
        seleccionarRegistros();
        setActivate(true);
    }, []);

    const cerrar = () => {
        props.setTabla(0)
    }

    // Función para generar colores
    const generateColors = (count) => {
        const colorsPalette = [
            "#3498DB", "#2ECC71", "#F39C12", "#9B59B6", "#E74C3C", 
            "#1ABC9C", "#E67E22", "#95A5A6", "#34495E", "#16A085",
            "#27AE60", "#2980B9", "#8E44AD", "#2C3E50", "#D35400",
            "#C0392B", "#BDC3C7", "#7F8C8D", "#F1C40F", "#E67E22"
        ];
        return Array.from({ length: count }, (_, i) => colorsPalette[i % colorsPalette.length]);
    };

    // Configuración de la gráfica - AHORA DINÁMICA SEGÚN LOS TIPOS REALES
    const chartData = {
        labels: chartLabels,
        datasets: [
            {
                label: "Distribución por Tipo de Cuenta",
                data: chartValues,
                backgroundColor: backgroundColors,
                borderColor: "#ffffff",
                borderWidth: 2,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                backgroundColor: "rgba(0,0,0,0.8)",
                padding: 10,
                cornerRadius: 4,
                callbacks: {
                    label: function(context) {
                        const label = context.label || '';
                        const value = context.raw || 0;
                        const total = context.dataset.data.reduce((a, b) => a + b, 0);
                        const percentage = ((value / total) * 100).toFixed(1);
                        return `${label}: ${value}`;
                    }
                }
            },
        },
    };

    // Calcular total de cuentas
    const totalCuentas = records.length;
    const activas = records.filter(r => r.status === 1 || r.status === "1" || r.activo === true).length;
    const inactivas = records.filter(r => r.status !== 1 && r.status !== "1" && r.activo !== true).length;

    return (
        <div style={styles.parent}>
            {/* Cards con estadísticas */}
            <div style={styles.div1}>
                <CardsModule
                    total={totalCuentas}
                    activos={activas}
                    inactivos={inactivas}
                />
            </div>

            {/* Tabla de cuentas bancarias */}
            <div style={styles.div2}>
                <div
                    className="col-12 m-0 p-2 border rounded"
                    style={{
                        height: "60vh",
                    }}
                >
                    <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
                        <h3 className="fw-bold m-0">Gestión de Cuentas Bancarias</h3>
                        <a
                            onClick={cerrar}
                            type="button"
                            className="text-light fw-bold fs-6"
                        >
                            Salir <i className="fas fa-times ms-2"></i>
                        </a>
                    </header>

                    <div className="col-12 m-0 mt-3 p-0 d-flex justify-content-between">
                        <div className="col-4 m-0 p-0">
                            <div className="w-100 m-0 p-0 input-group input-group-sm text-uppercase">
                                <input
                                    ref={txtBuscador}
                                    type="search"
                                    className="search-input form-control form-control-sm rounded"
                                    onChange={handleSearch}
                                    placeholder="Buscar cuenta bancaria..."
                                />
                            </div>
                        </div>
                        <div className="col-auto m-0 p-0">
                            <PrimaryButton
                                icon="fa-plus m-0 p-0"
                                onClick={gestionarBanco(1, '', permiso.toString().substring(1, 2))}
                                disabled={permiso.toString().substring(1, 2) !== '1'}
                                title="Agregar Cuenta Bancaria"
                            />
                        </div>
                    </div>

                    <div className="col-12 m-0 p-0 mt-3">
                        <TblContainer>
                            <TblHead />
                            <tbody>
                                {records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item.idcuentabancaria || index} style={{ padding: "0" }}>
                                        <td style={{
                                            fontSize: "12px",
                                            textAlign: "center",
                                            width: "80px"
                                        }}>
                                            {item.idcuentabancaria}
                                        </td>
                                        <td style={{
                                            fontSize: "12px",
                                            textAlign: "left",
                                            width: "400px"
                                        }}>
                                            {item.nombre?.trim() || ''}
                                        </td>
                                        <td style={{
                                            fontSize: "12px",
                                            textAlign: "center",
                                            width: "180px"
                                        }}>
                                            {item.cuentabancaria?.trim() || ''}
                                        </td>
                                        <td
                                            align="center"
                                            className="align-baseline"
                                            style={{
                                                fontSize: "10px",
                                                textAlign: "center",
                                                width: "180px",
                                                padding: 0,
                                            }}
                                        >
                                            <button
                                                onClick={gestionarBanco(4, item.idcuentabancaria, permiso.toString().substring(0, 1))}
                                                className={permiso.toString().substring(0, 1) === '1'
                                                    ? 'btn btn-sm btn-info rounded-circle'
                                                    : 'btn btn-sm btn-secondary rounded-circle'
                                                }
                                            >
                                                <i className="fas fa-eye"></i>
                                            </button>
                                            <a> &nbsp; </a>
                                            <button
                                                onClick={gestionarBanco(2, item.idcuentabancaria, permiso.toString().substring(2, 3))}
                                                className={permiso.toString().substring(2, 3) === '1'
                                                    ? 'btn btn-sm btn-warning rounded-circle'
                                                    : 'btn btn-sm btn-secondary rounded-circle'
                                                }
                                            >
                                                <i className="fa fa-edit"></i>
                                            </button>
                                            <a> &nbsp; </a>
                                            <button
                                                onClick={gestionarBanco(3, item.idcuentabancaria, permiso.toString().substring(3, 4))}
                                                className={permiso.toString().substring(3, 4) === '1'
                                                    ? 'btn btn-sm btn-danger rounded-circle'
                                                    : 'btn btn-sm btn-secondary rounded-circle'
                                                }
                                            >
                                                <i className="fa fa-trash-alt"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </TblContainer>
                        <TblPagination />
                    </div>
                </div>
            </div>

            {/* Gráfica de distribución de cuentas bancarias por TIPO */}
            <div style={styles.div3}>
                <Card
                    sx={{
                        borderRadius: 4,
                        boxShadow: 3,
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <CardContent
                        sx={{
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                        }}
                    >
                        <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            align="center"
                            mb={1}
                            color="text.secondary"
                            style={{
                                textTransform: "uppercase",
                            }}
                        >
                            Distribución por Tipo de Cuenta
                        </Typography>

                        {/* Contenedor del gráfico */}
                        <Box
                            sx={{
                                flex: 1,
                                position: "relative",
                                width: "100%",
                                minHeight: "250px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            {chartLabels.length > 0 ? (
                                <Pie data={chartData} options={chartOptions} />
                            ) : (
                                <Typography variant="body2" color="text.secondary">
                                    No hay datos para mostrar
                                </Typography>
                            )}
                        </Box>

                        {/* Leyenda del gráfico */}
                        {chartLabels.length > 0 && (
                            <Box
                                sx={{ flexGrow: 0, overflowY: "auto", maxHeight: "40%", mt: 1 }}
                            >
                                <List dense sx={{ py: 0 }}>
                                    {chartLabels.map((label, index) => {
                                        // Limpiar el label para mostrarlo
                                        const cleanLabel = label.trim();
                                        const total = chartValues.reduce((a, b) => a + b, 0);
                                        const percentage = ((chartValues[index] / total) * 100).toFixed(1);
                                        
                                        return (
                                            <React.Fragment key={cleanLabel}>
                                                <ListItem
                                                    sx={{ px: 1, py: 0.5 }}
                                                    secondaryAction={
                                                        <Typography
                                                            variant="body2"
                                                            fontWeight="bold"
                                                            color="text.primary"
                                                        >
                                                            {chartValues[index]} 
                                                        </Typography>
                                                    }
                                                >
                                                    <Box
                                                        sx={{
                                                            width: 12,
                                                            height: 12,
                                                            borderRadius: "50%",
                                                            backgroundColor: backgroundColors[index],
                                                            mr: 2,
                                                            flexShrink: 0,
                                                        }}
                                                    />
                                                    <ListItemText
                                                        style={{
                                                            textTransform: "uppercase",
                                                        }}
                                                        primaryTypographyProps={{
                                                            variant: "caption",
                                                            noWrap: true,
                                                            sx: { fontSize: "11px" },
                                                        }}
                                                        primary={cleanLabel}
                                                    />
                                                </ListItem>
                                                {index < chartLabels.length - 1 && (
                                                    <Divider component="li" />
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                </List>
                            </Box>
                        )}
                    </CardContent>
                </Card>
            </div>

            <GestionarCuentasBancarias
                show={mostrar2}
                onHideCancela={cerrarModal}
                operacion={operacion}
                bancos={bancos}
                onHideRenderizar={seleccionarRegistros}
            />

            <Dimmer active={activate} inverted />
            
            <Mensaje
                mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })}
            />
            
            <MensajeSiNo
                mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })}
                onHideSi={handleCloseSi}
            />
            
            <Toasts
                show={toast.mostrar}
                titulo={toast.titulo}
                mensaje={toast.mensaje}
                onHideCancela={cerrarToast}
            />
        </div>
    );
}

const styles = {
    parent: {
        display: "grid",
        gridTemplateColumns: "1fr 25%",
        gridTemplateRows: "auto 1fr",
        gridColumnGap: "20px",
        gridRowGap: "20px",
        height: "100vh",
        padding: "20px",
        backgroundColor: "#f5f5f5",
    },
    div1: {
        gridArea: "1 / 1 / 2 / 2",
    },
    div2: {
        gridArea: "2 / 1 / 3 / 2",
        overflow: "auto",
    },
    div3: {
        gridArea: "1 / 2 / 3 / 3",
        height: "82vh",
    },
};

export default TablaCuentasBancarias;